// 单文件引入方式

import ImageUploader from './Index.vue'

export default {
  install(Vue) {
    Vue.component('ZuiImageUploader', ImageUploader)
  }
}

export { ImageUploader }
